export const STATUS = {
  OK: 'OK',
  MAINTENANCE: 'MAINTENANCE',
} as const

export type Status = keyof typeof STATUS

export interface ApplicationStatusResponse {
  status: Status
  topic: string
  content: string
  hours: string
}



// WEBPACK FOOTER //
// ./src/API/Info/info.Models.ts